import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { useEffect, useRef } from 'react';

import useConstant from './useConstant';

type UseDebounceOptions = {
  /** @default 300 */
  millis?: number;
};

/**
 * @param func any function handler. SHOULD BE WRAPPED with Reacts useCallback to avoid unnecessary func assignments
 */
export const useDebounce = <TArgs extends unknown[], TResult>(
  func: (...args: TArgs) => TResult,
  opts?: UseDebounceOptions
) => {
  const funcRef = useRef(func);

  useEffect(() => {
    funcRef.current = func;
  }, [func]);

  return useConstant(() => AwesomeDebouncePromise((...args: TArgs) => funcRef.current(...args), opts?.millis || 300));
};
